import React from 'react';

 function Space() {
    return(
        <div className="container text-center mb-5" style={{ marginTop: "100px" }}>
            <div className="hover-underline heading">“Harvest Smarter, Not Harder”<br></br>
            Join India’s growing agri-tech movement today.
                </div>
        </div>
    )
 }

 export default Space;